module.exports = __webpack_public_path__ + "img/welcome-3.4c320e8c.png";